const contentTypes = {
  en: {
    tutorial: 'Tutorial',
    faq: 'FAQ',
    faqLong: 'Frequently Asked Questions',
    guide: 'Guide',
    video: 'Video'
  },
  'es-ud': {
    tutorial: 'Tutorial',
    faq: 'FAQ',
    faqLong: 'Preguntas Frecuentes',
    guide: 'Guía',
    video: 'Video'
  },
  es: {
    tutorial: 'Tutorial',
    faq: 'FAQ',
    faqLong: 'Preguntas Frecuentes',
    guide: 'Guía',
    video: 'Video'
  }
}

export default contentTypes



// WEBPACK FOOTER //
// ./src/constants/content-types.js